import React from "react";

/**
 * StatusBadge — tiny pill used for mission status, roles, raritys.
 * Tone uses semantic tokens with 12% bg + full text color.
 */
const tones = {
    neutral: "bg-md-text-2/10 text-md-text-2",
    primary: "bg-md-primary/10 text-md-primary",
    gold: "bg-md-secondary/15 text-md-secondary",
    success: "bg-md-accent/15 text-md-accent",
    warning: "bg-md-warning/15 text-md-warning",
    danger: "bg-md-danger/15 text-md-danger",
    commune: "bg-rarity-commune/15 text-rarity-commune",
    counco: "bg-rarity-commune/15 text-rarity-commune", // legacy alias
    unco: "bg-rarity-unco/15 text-rarity-unco",
    rare: "bg-rarity-rare/15 text-rarity-rare",
    holo: "bg-rarity-holo/15 text-rarity-holo",
    reverse: "bg-rarity-commune-reverse/15 text-rarity-commune-reverse",
    "rare-reverse": "bg-rarity-rare-reverse/15 text-rarity-rare-reverse",
    exv: "bg-rarity-ex-v/15 text-rarity-ex-v",
};

export function StatusBadge({ tone = "neutral", icon, children, className = "", testId }) {
    return (
        <span
            data-testid={testId}
            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider ${tones[tone] || tones.neutral} ${className}`}
        >
            {icon}
            {children}
        </span>
    );
}

export default StatusBadge;
